/**
 * Path to a managed disclosure document for an application.
 *
 * Points at the Next proxy route rather than acquire-api directly. That indirection
 * is required, not cosmetic: the API's disclosure endpoint sits behind
 * `verifyClientId`, and a plain browser anchor sends no X-Cotribute-Client-Id
 * header, so linking straight to the API would 401. See utils/disclosurePdfProxy.
 *
 * Relative on purpose so it resolves against whichever app is serving the flow.
 * Both acquire-flows and embeds carry this route, since embeds renders the flow
 * on its own origin.
 *
 * Returns undefined when either input is missing so callers can decide not to
 * render a link at all.
 */
export const disclosureDocumentUrl = (
  applicationId?: string,
  disclosureSlug?: string | null
): string | undefined => {
  if (!applicationId || !disclosureSlug) return undefined;
  return `/onboarding-applications/${applicationId}/disclosures/${disclosureSlug}`;
};

export default disclosureDocumentUrl;
